module.exports = __webpack_public_path__ + "img/milestone__01--big.c9cd0e6a.png";